<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :after-save="afterSave"
    :model="model"
    :rules="rules"
    :readonly="readonly"
  >
    <template slot="form" v-if="model">
      <form-section>
        <el-row>
          <el-col :span="12">
            <rest-form-item
              :label="$t('Alarms_Field_MessageType')"
              prop="message_type"
            >
              <enum-select
                v-model="model.message_type"
                :placeholder="$t('Alarms_Field_MessageType')"
                :options="MessageTypeLabel"
                :number="true"
              />
            </rest-form-item>

            <rest-form-item
              :label="$t('Alarms_Field_Threshold')"
              prop="treshold"
            >
              <el-input
                v-model="model.treshold"
                :placeholder="$t('Alarms_Field_Threshold')"
              />
            </rest-form-item>

            <rest-form-item :label="$t('Alarms_Field_Period')" prop="period">
              <enum-select
                v-model="model.period"
                :placeholder="$t('Alarms_Field_Period')"
                :options="AlarmPeriodLabels"
                :number="true"
              />
            </rest-form-item>
          </el-col>

          <el-col :span="12">
            <rest-form-item :label="$t('Alarms_Field_Emails')" prop="emails">
              <el-input
                type="textarea"
                class="emails"
                v-model="model.emails"
                :placeholder="$t('Alarms_Field_Emails')"
              />
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import { MessageTypeLabel } from '@/common/enum/MessageTypeEnum'
import { AlarmPeriodLabels } from '@/modules/alarms/enum/AlarmPeriodLabels'
import RestFormPage from '@/common/components/rest/RestFormPage'
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormSection from '@/common/components/form/FormSection'
import EnumSelect from '@/common/components/form/EnumSelect'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'AlarmFormPage',

  components: {
    EnumSelect,
    RestFormPage,
    RestFormItem,
    FormSection
  },

  props: {
    readonly: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      model: this.defaultModel(),
      MessageTypeLabel,
      AlarmPeriodLabels
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'get',
          url: `alarms/${this.$route.query.id}`,
          handler: data => {
            this.model = data
          }
        })
      } else {
        return null
      }
    },

    saveEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'patch',
          url: `alarms/${this.$route.query.id}`
        })
      } else {
        return projectEndpoint({
          method: 'post',
          url: `alarms`
        })
      }
    },

    rules() {
      return {
        message_type: {
          required: true
        },
        treshold: {
          required: true
        },
        period: {
          required: true
        },
        emails: {
          required: true
        }
      }
    },

    features() {
      return this.$store.state.app.features
    }
  },

  methods: {
    defaultModel() {
      if (this.$route.query.id) {
        return null
      } else {
        return {}
      }
    },

    afterSave() {
      this.$router.push(
        projectRoute({
          name: 'AlarmList'
        })
      )
    }
  }
}
</script>

<style scoped>
>>> .emails .el-textarea__inner {
  height: 224px;
}
</style>



// WEBPACK FOOTER //
// src/modules/alarms/pages/AlarmFormPage.vue